import { createContext, useContext } from "react";

/*
  Visual variant of the public site.
  "default": the new identity (orange, K mark).
  "gammel":  same layout and content, but the colours and logo of the current kvinnheradelektro.no
             (blue, lime-green socket mark). Served on /gammel for side-by-side comparison.
*/
export const VARIANTS = {
  default: { id: "default", home: "/", themeClass: "" },
  gammel: { id: "gammel", home: "/gammel", themeClass: "theme-gammel" },
};

export const VariantContext = createContext(VARIANTS.default);
export const useVariant = () => useContext(VariantContext);
